import { Environment } from "../../../environment";
import { Api, IPaginacao } from "../axios-config";
import { IIndice } from "../indice/IndiceService";

export interface IIndice_Documento {
    idIndice: number,
    idDocumento: number,
    valor: string | null,
    dataInicial: string | null,
    dataFinal: string | null,
}

export interface IAlterarIndice_Documento extends IIndice_Documento {
    indice: IIndice;
}

export interface IDocumento {
    localV1: string | null,
    localV2: string | null,
    dataUpload: string,
    estado: true,
    idCaixa: number,
    idDocumento: number,
    idTipo: number,
    local: string,
    nomeArquivo: string,
    qtdePaginas: number,
    indice_documentos: IIndice_Documento[],
    localizador: string,
    codBarras: string,
    corrente: string,
    intermediaria: string,
}

export interface IEmail {
    destinatario: string,
    assunto: string,
    corpo: string,
}

export interface IAlterarTipoDocumentoPayload {
    idTipo: number,
    idDocumento: number,
    indice_documentos: IIndice_Documento[],
}

interface IListagemDocumento {
    documentos: IDocumento[],
    paginacao: IPaginacao
}


const createList = async (dados: FormData, idTipo: number, idCaixa: string): Promise<number[] | Error> => {
    try {
        if (idCaixa === "null") {
            idCaixa = "";
        }
        const { data } = await Api.post(`Documento/pasta?idTipo=${idTipo}&idCaixa=${idCaixa}`, dados, { headers: { 'Content-Type': 'multipart/form-data' } });

        if (data) {
            return data;
        }

        return new Error('Erro ao criar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro');
    }
};




const createIndice_Documento = async (dados: IIndice_Documento[]) => {

    dados.map((dado) => {
        if (dado.dataInicial === "") {
            dado.dataInicial = null;
        }
        if (dado.dataFinal === "") {
            dado.dataFinal = null;
        }
    });

    try {
        const { data } = await Api.post(`Indice_documento`, dados);

        if (data) {
            return data;
        }

        return new Error('Erro ao criar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro');
    }
};

const getIndice_DocumentoByIdDocumento = async (idDocumento: number): Promise<IAlterarIndice_Documento[] | Error> => {
    try {
        const { data } = await Api.get(`/Indice_documento/porIdDoc?idDoc=${idDocumento}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao criar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro');
    }
};

const indexar = async (idDocumento: number) => {
    try {
        const { data } = await Api.post(`Conteudo/indexar?id=${idDocumento}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao criar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro');
    }
};

const indexarList = async (idsDocumento: number[]) => {
    try {
        const { data } = await Api.post(`Conteudo/indexarLista`, idsDocumento);

        if (data) {
            return data;
        }

        return new Error('Erro ao criar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro');
    }
};


const consultarPorTexto = async (textoBusca: string, cnpj: string, idUnidade: number, idSetor: number, idTipo: number, page = 1): Promise<IListagemDocumento | Error> => {

    //troca o & comercial para que não seja identificado como queryString
    textoBusca = textoBusca.replaceAll("&", "($and)");

    try {
        var url = `Conteudo/pesquisaTextual?PageNumber=${page}&PageSize=${Environment.LIMITE_DE_LINHAS}&stringBusca=${textoBusca}`;

        if (idTipo != null && idTipo != undefined && idTipo != 0) {
            url += `&idTipo=${idTipo}`;
        }
        if (idSetor != null && idSetor != 0 && idSetor != undefined) {
            url += `&idSetor=${idSetor}`;
        }
        if (idUnidade != null && idUnidade != 0 && idTipo != undefined) {
            url += `&idUnidade=${idUnidade}`;
        }
        if (cnpj != undefined && cnpj != "") {
            url += `&cnpj=${cnpj}`;
        }

        const { data } = await Api.get(url);

        if (data) {
            return data;
        }

        return new Error('Erro ao consultar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao consultar o registro');
    }
};

const consultarPorLocalizador = async (localizador: string, page = 1, codBarras?: string): Promise<IListagemDocumento | Error> => {
    try {
        var request = `Documento/pesquisar/caixa?PageNumber=${page}&PageSize=${Environment.LIMITE_DE_LINHAS}&loc=${localizador}`;

        if (codBarras?.trim() !== "") {
            request = `Documento/pesquisar/caixa?PageNumber=${page}&PageSize=${Environment.LIMITE_DE_LINHAS}&codBarras=${codBarras}`;
        }

        const { data } = await Api.get(request);

        if (data) {
            return data;
        }

        return new Error('Erro ao consultar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao consultar o registro');
    }
};

const consultarPorIdTipo = async (idTipo: number, page = 1): Promise<IListagemDocumento | Error> => {
    try {
        const { data } = await Api.get(`Documento/documentosPorTipo?PageNumber=${page}&PageSize=${Environment.LIMITE_DE_LINHAS}&idTipo=${idTipo}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao consultar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao consultar o registro');
    }
};


const consultarPorIndices = async (idTipo: number, dadosIndice: Omit<IIndice_Documento, 'idDocumento'>[], page = 1): Promise<IListagemDocumento | Error> => {
    try {
        const { data } = await Api.post(`Documento/pesquisar/indice?PageNumber=${page}&PageSize=${Environment.LIMITE_DE_LINHAS}&idTipo=${idTipo}`, dadosIndice);

        if (data) {
            return data;
        }

        return new Error('Erro ao consultar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao consultar o registro');
    }
};

const pesquisarDoc = async (idDocumento: number, onDownloadProgress?: (percent: number) => void): Promise<{ blob: Blob; nomeArquivo: string; headers: any } | Error> => {
    try {

        const response = await Api.get(`/Documento/pesquisar?idDocumento=${idDocumento}`, {
            responseType: "blob",
            onDownloadProgress: (event) => {
                if (event.total && onDownloadProgress) {
                    const percent = (event.loaded / event.total) * 100;
                    onDownloadProgress(percent);
                }
            },
        });
       
        const contentDisposition = response.headers['content-disposition'];
        
        let nomeArquivo = 'arquivo.pdf';

        if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^"]+)"?/);
            if (match && match[1]) {
                nomeArquivo = decodeURIComponent(match[1]);
            }
        }

        return { blob: response.data, nomeArquivo, headers: response.headers  };
    } catch (error: any) {
        return new Error(error?.response?.data?.message || 'Erro ao baixar o documento');
    }

};

const mesclar = async (idDocumento: number, ordem: boolean, dados: FormData) => {
    try {
        const { data } = await Api.post(`Documento/mesclarDocumentos?id=${idDocumento}&ordem=${ordem}`, dados, { headers: { 'Content-Type': 'multipart/form-data' } });

        if (data) {
            return data;
        }

        return new Error('Erro ao criar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro');
    }
};

const voltarVersao = async (idDocumento: number) => {
    try {
        const { data } = await Api.post(`Documento/voltarVersao?idDocumento=${idDocumento}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao criar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro');
    }
};

const desativar = async (idDocumento: number) => {
    try {
        const { data } = await Api.patch(`Documento/alterarEstado?idDocumento=${idDocumento}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao desativar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao desativar o registro');
    }
};

const alterarTipo = async (dados: IAlterarTipoDocumentoPayload) => {
    try {
        const { data } = await Api.put(`Documento/alterarTipo`, dados);

        if (data) {
            return data;
        }

        return new Error('Erro ao alterar o tipo do documento');
    } catch (error) {
        console.error(error);

        return new Error((error as { message: string }).message || 'Erro ao alterar o tipo do documento');
    }
};

const enviarEmail = async (email: IEmail) => {
    try {
        const { data } = await Api.post(`Documento/enviarEmail`, email);

        if (data) {
            return data;
        }

        return new Error('Erro ao enviar email');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao enviar email');
    }
};

const docuementoNaoIndexado = async (idCaixa: number): Promise<number[] | Error> => {
    try {
        const { data } = await Api.get(`Documento/NaoIndexados?idCaixa=${idCaixa}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao consultar documento não indexado');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao consultar documento não indexado');
    }
}

const getById = async (idDocumento: number): Promise<string | Error> => {
    try {
        const { data } = await Api.get(`/Documento/pesquisar?idDocumento=${idDocumento}`, { responseType: 'blob' });
        if (data) {
            const url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
            return url;
        } else {
            return new Error('Erro ao consutar o registro');
        }

    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao consultar o registro');
    }
}

const certificarEmLote = async (selectedIdTipo: number, senha: string, file: File): Promise<string | Error> => {
    try {
        console.log(file)

        // Convert the file to base64
        const toBase64 = (file: File): Promise<string> => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve((reader.result as string).split(',')[1]);
            reader.onerror = error => reject(error);
        });

        const certificadoBase64 = await toBase64(file);

        // Create the CertificadoDigital object
        const certificadoDigital = {
            Certificado: certificadoBase64,
            Senha: senha
        };

        const { data } = await Api.post(`Documento/certificarPorTipo?idTipo=${selectedIdTipo}`, certificadoDigital, {
            headers: { 'Content-Type': 'application/json' }
        });

        if (data instanceof Error) {
            return new Error("Erro ao certificar em lote");
        }
        return data;

    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro');
    }
};

const paraCertificar = async (idTipo: number): Promise<number | Error> => {
    try {
        const { data } = await Api.get(`Documento/paraCertificar?idTipo=${idTipo}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao consultar documentos para certificar');
    } catch (error) {
        console.error(error);

        return new Error((error as { message: string }).message || 'Erro ao consultar documentos para certificar');
    }
}



export const DocumentoService = {
    createList,
    createIndice_Documento,
    getIndice_DocumentoByIdDocumento,
    indexar,
    indexarList,
    consultarPorTexto,
    consultarPorLocalizador,
    consultarPorIdTipo,
    consultarPorIndices,
    pesquisarDoc,
    mesclar,
    voltarVersao,
    desativar,
    alterarTipo,
    enviarEmail,
    docuementoNaoIndexado,
    getById,
    certificarEmLote,
    paraCertificar,
}